import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'CheckboxPopup',
    components: {
        CashiersTab: () => import('./cashiers/CashiersTab.vue'),
        PaymentMappingsTab: () => import('./PaymentMappingsTab.vue'),
        FiscalizationTriggersTab: () => import('./FiscalizationTriggersTab.vue'),
    },
    props: ['popupType', 'selectedItem'],
    data() {
        return {
            activeTab: 'cashiers',
        };
    },
    computed: {
        ...mapGetters({
            options: 'config/options',
        }),
    },
    methods: {
        closePopup() {
            this.$emit('closePopup');
        },
        ...mapActions({
            getOptions: 'config/getOptions',
            editOptions: 'config/editOptions',
        }),
    },
}

